import { useContext, useEffect, useState } from 'react';
import '@/core/firebase';
import { getAuth } from 'firebase/auth';
import { FindFirebaseIdUsecase } from '@/domain/use-cases/users/findFireBaseId';
import { UsersRepoIml } from '@/modules/users/adapters/repositories';
import { AppContext } from '../context/PageContext';
import { useNavigate } from 'react-router-dom';

export const useAuthorization = (permission: string) => {
  const getUserByFirebaseId = new FindFirebaseIdUsecase(new UsersRepoIml());
  const [isAuthorized, setIsAuthorized] = useState<boolean | undefined>(undefined);
  const { userData } = useContext(AppContext);
  const navigate = useNavigate();
  if (!permission) {
    setIsAuthorized(true);
  }

  const execAuthorization = async () => {
    try {
      const user = getAuth().currentUser;

      if (user) {
        const userLogin = await getUserByFirebaseId.run(user.uid);
        console.log('🚀🚀🚀 ::::: useAuthentication.ts:24 ::::: userLogin:', userLogin);
        if (userLogin.permissions.includes(permission)) {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } else {
        setIsAuthorized(false);
      }
    } catch (error: unknown) {
      console.error('Authorization failed:', error);
      navigate('/login');
      setIsAuthorized(false);
    }
  };

  useEffect(() => {
    execAuthorization();
  }, [userData]);

  return { isAuthorized };
};
